import { render, staticRenderFns } from "./app_shop_admin.vue?vue&type=template&id=748f05d1&scoped=true&"
import script from "./app_shop_admin.vue?vue&type=script&lang=js&"
export * from "./app_shop_admin.vue?vue&type=script&lang=js&"
import style0 from "./app_shop_admin.vue?vue&type=style&index=0&id=748f05d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748f05d1",
  null
  
)

export default component.exports